import { useMemo } from 'react';
import { useURLParams } from './useURLParams';

// gives you an array of strings that should be bolded in the search results
const useSearchReasons = (): string[] => {
    const { searchTerm } = useURLParams();

    const boldedTerms = useMemo(() => {
        let arr: string[] = [];
        if (searchTerm?.splitTerm) arr = [...searchTerm.splitTerm];
        else arr = [];

        return arr;
    }, [searchTerm]);

    return boldedTerms;
};

export { useSearchReasons };
